import React from "react";
import { Button, Modal, Table } from "react-bootstrap";

interface ModalProps<T> {
  isOpen: boolean;
  onRowSelect: (selectedItem: T) => void;
  onClose: () => void;
  allItems: T[] | undefined;
  renderRow: (item: T) => React.ReactNode;
  title: string;
  tableColumnHeaders: string[];
}

const SelectModal = <T,>({
  isOpen,
  title,
  onRowSelect,
  onClose,
  allItems,
  renderRow,
  tableColumnHeaders,
}: ModalProps<T>) => {
  return (
    <Modal show={isOpen} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <Table responsive hover>
          <thead>
            <tr>
              {tableColumnHeaders.map((header, index) => (
                <th key={index}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allItems?.map((item, index) => (
              <tr key={index} onClick={() => onRowSelect(item)}>
                {renderRow(item)}
              </tr>
            ))}
          </tbody>
        </Table>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SelectModal;
